var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "wrapper"
  }, [_c('h1', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v(_vm._s(_vm.eventInfo.eventName) + "报名")]), _c('a-steps', {
    attrs: {
      "current": _vm.step,
      "type": "navigation"
    }
  }, [_c('a-step', {
    attrs: {
      "title": "信息填写"
    }
  }), _c('a-step', {
    attrs: {
      "title": "信息确认"
    }
  }), _c('a-step', {
    attrs: {
      "title": "报名成功"
    }
  })], 1), _c('a-divider'), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.step == 0 || _vm.step == 1,
      expression: "step==0 || step==1"
    }]
  }, [_c('a-form', {
    attrs: {
      "form": _vm.form,
      "label-col": _vm._isMobile() ? {} : {
        span: 8
      },
      "wrapper-col": _vm._isMobile() ? {} : {
        span: 12
      },
      "layout": _vm._isMobile() ? 'vertical' : 'horizontal'
    }
  }, [_c('a-row', {
    attrs: {
      "justify": "center",
      "type": "flex"
    }
  }, [_c('a-col', {
    attrs: {
      "xs": 24,
      "sm": 20
    }
  }, [_c('a-form-item', {
    attrs: {
      "label": "选择项目"
    }
  }, [_c('j-category-select', {
    directives: [{
      name: "decorator",
      rawName: "v-decorator",
      value: ['eventCategory', _vm.validatorRules.eventCategory],
      expression: "['eventCategory', validatorRules.eventCategory]"
    }],
    attrs: {
      "dropdownStyle": {
        maxHeight: '300px',
        overflow: 'auto'
      },
      "mutex": true,
      "pid": _vm.eventInfo.eventCategory,
      "onlyLeaf": true,
      "getPopupContainer": function getPopupContainer(triggerNode) {
        return triggerNode.parentNode;
      },
      "multiple": _vm.eventInfo.applyMulti == 1,
      "treeCheckable": _vm.eventInfo.applyMulti == 1,
      "disabled": _vm.step == 1,
      "placeholder": "请选择项目"
    },
    on: {
      "change": _vm.onEventCategoryChange
    }
  })], 1)], 1), _c('a-col', {
    attrs: {
      "xs": 24,
      "sm": 20
    }
  }, [_c('a-form-item', {
    attrs: {
      "label": "姓名"
    }
  }, [_c('a-input', {
    directives: [{
      name: "decorator",
      rawName: "v-decorator",
      value: ['realname', _vm.validatorRules.realname],
      expression: "['realname', validatorRules.realname]"
    }],
    attrs: {
      "disabled": _vm.step == 1
    }
  })], 1)], 1), _vm.applyConfig.idcard > 0 ? _c('a-col', {
    attrs: {
      "xs": 24,
      "sm": 20
    }
  }, [_c('a-form-item', {
    attrs: {
      "label": "证件号码"
    }
  }, [_c('a-input', {
    directives: [{
      name: "decorator",
      rawName: "v-decorator",
      value: ['idcard', _vm.validatorRules.idcard[_vm.idcardType]],
      expression: "['idcard', validatorRules.idcard[idcardType]]"
    }],
    attrs: {
      "disabled": _vm.step == 1,
      "placeholder": "身份证/护照/台胞证"
    }
  }), _c('a-radio-group', {
    attrs: {
      "disabled": _vm.step == 1,
      "default-value": "1",
      "button-style": "solid"
    },
    on: {
      "change": _vm.schoolSelected
    },
    model: {
      value: _vm.idcardType,
      callback: function callback($$v) {
        _vm.idcardType = $$v;
      },
      expression: "idcardType"
    }
  }, [_c('a-radio-button', {
    attrs: {
      "value": 1
    }
  }, [_vm._v("身份证")]), _c('a-radio-button', {
    attrs: {
      "value": 2
    }
  }, [_vm._v("护照")]), _c('a-radio-button', {
    attrs: {
      "value": 3
    }
  }, [_vm._v("其他")])], 1)], 1)], 1) : _vm._e(), _vm.applyConfig.sex > 0 ? _c('a-col', {
    attrs: {
      "xs": 24,
      "sm": 20
    }
  }, [_c('a-form-item', {
    attrs: {
      "label": "性别"
    }
  }, [_c('a-radio-group', {
    directives: [{
      name: "decorator",
      rawName: "v-decorator",
      value: ['sex', _vm.validatorRules.sex],
      expression: "['sex', validatorRules.sex]"
    }],
    attrs: {
      "disabled": _vm.step == 1
    }
  }, [_c('a-radio-button', {
    attrs: {
      "value": 1
    }
  }, [_vm._v(" 男 ")]), _c('a-radio-button', {
    attrs: {
      "value": 2
    }
  }, [_vm._v(" 女 ")])], 1)], 1)], 1) : _vm._e(), _vm.applyConfig.photo > 0 ? _c('a-col', {
    attrs: {
      "xs": 24,
      "sm": 20
    }
  }, [_c('a-form-item', {
    attrs: {
      "label": "证件照",
      "required": _vm.applyConfig.photo == 2
    }
  }, [_c('a-tag', {
    attrs: {
      "color": "orange"
    }
  }, [_vm._v("一寸蓝底免冠照，jpg或png格式，文件大小100KB以上5MB以内")]), _c('a-row', [_c('a-col', {
    attrs: {
      "xs": 24,
      "md": 12
    }
  }, [_c('div', {
    staticClass: "ant-upload-preview",
    on: {
      "click": _vm.showPhotoModal
    }
  }, [_c('a-icon', {
    staticClass: "upload-icon",
    attrs: {
      "type": "cloud-upload-o"
    }
  }), _c('div', {
    staticClass: "mask"
  }, [_c('a-icon', {
    attrs: {
      "type": "plus"
    }
  })], 1), _vm.userInfo ? _c('img', {
    attrs: {
      "src": _vm.userInfo.photo_url
    }
  }) : _vm._e()], 1)]), _c('a-col', {
    staticClass: "photo-example",
    attrs: {
      "xs": 24,
      "md": 12
    }
  }, [_c('img', {
    attrs: {
      "width": "180",
      "height": "252",
      "src": require("../assets/photo-example.png"),
      "alt": "示例照片"
    }
  }), _c('h2', {
    staticClass: "tips"
  }, [_vm._v("示例照片")])])], 1)], 1)], 1) : _vm._e(), _vm.applyConfig.grade > 0 ? _c('a-col', {
    attrs: {
      "xs": 24,
      "sm": 20
    }
  }, [_c('a-form-item', {
    attrs: {
      "label": "年级"
    }
  }, [_c('j-dict-select-tag', {
    directives: [{
      name: "decorator",
      rawName: "v-decorator",
      value: ['grade', _vm.validatorRules.grade],
      expression: "['grade', validatorRules.grade]"
    }],
    attrs: {
      "disabled": _vm.step == 1,
      "trigger-change": true,
      "dictCode": "grade",
      "placeholder": "请选择年级"
    }
  })], 1)], 1) : _vm._e(), _vm.applyConfig.email > 0 ? _c('a-col', {
    attrs: {
      "xs": 24,
      "sm": 20
    }
  }, [_c('a-form-item', {
    attrs: {
      "label": "邮箱"
    }
  }, [_c('a-input', {
    directives: [{
      name: "decorator",
      rawName: "v-decorator",
      value: ['email', _vm.validatorRules.email],
      expression: "['email', validatorRules.email]"
    }],
    attrs: {
      "disabled": _vm.step == 1
    }
  })], 1)], 1) : _vm._e(), _vm.applyConfig.teacherName > 0 ? _c('a-col', {
    attrs: {
      "xs": 24,
      "sm": 20
    }
  }, [_c('a-form-item', {
    attrs: {
      "label": "辅导老师"
    }
  }, [_c('a-input', {
    directives: [{
      name: "decorator",
      rawName: "v-decorator",
      value: ['teacherName', _vm.validatorRules.teacherName],
      expression: "['teacherName', validatorRules.teacherName]"
    }],
    attrs: {
      "disabled": _vm.step == 1
    }
  })], 1)], 1) : _vm._e(), _vm.applyConfig.teacherPhone > 0 ? _c('a-col', {
    attrs: {
      "xs": 24,
      "sm": 20
    }
  }, [_c('a-form-item', {
    attrs: {
      "label": "老师电话"
    }
  }, [_c('a-input', {
    directives: [{
      name: "decorator",
      rawName: "v-decorator",
      value: ['teacherPhone', _vm.validatorRules.teacherPhone],
      expression: "['teacherPhone', validatorRules.teacherPhone]"
    }],
    attrs: {
      "disabled": _vm.step == 1
    }
  })], 1)], 1) : _vm._e(), _vm.applyConfig.parentName > 0 ? _c('a-col', {
    attrs: {
      "xs": 24,
      "sm": 20
    }
  }, [_c('a-form-item', {
    attrs: {
      "label": "监护人"
    }
  }, [_c('a-input', {
    directives: [{
      name: "decorator",
      rawName: "v-decorator",
      value: ['parentName', _vm.validatorRules.parentName],
      expression: "['parentName', validatorRules.parentName]"
    }],
    attrs: {
      "disabled": _vm.step == 1
    }
  })], 1)], 1) : _vm._e(), _vm.applyConfig.address > 0 ? _c('a-col', {
    style: _vm._isMobile() ? {
      height: '180px'
    } : {},
    attrs: {
      "xs": 24,
      "sm": 20
    }
  }, [_c('a-form-item', {
    attrs: {
      "label": "所处省市"
    }
  }, [_c('j-area-linkage', {
    directives: [{
      name: "decorator",
      rawName: "v-decorator",
      value: ['address', _vm.validatorRules.address],
      expression: "['address', validatorRules.address]"
    }],
    attrs: {
      "disabled": _vm.step == 1,
      "type": _vm._isMobile() ? 'select' : 'cascader',
      "placeholder": "请选择省市区"
    }
  })], 1)], 1) : _vm._e(), _vm.applyConfig.addressDetailed > 0 ? _c('a-col', {
    attrs: {
      "xs": 24,
      "sm": 20
    }
  }, [_c('a-form-item', {
    attrs: {
      "label": "寄送地址"
    }
  }, [_c('a-input', {
    directives: [{
      name: "decorator",
      rawName: "v-decorator",
      value: ['addressDetailed', _vm.validatorRules.addressDetailed],
      expression: "['addressDetailed', validatorRules.addressDetailed]"
    }],
    attrs: {
      "placeholder": "请填写详细地址"
    }
  })], 1)], 1) : _vm._e(), _c('a-col', {
    attrs: {
      "xs": 24,
      "sm": 20
    }
  }, [_c('a-form-item', {
    attrs: {
      "label": "激活码"
    }
  }, [_c('a-switch', {
    attrs: {
      "disabled": _vm.step == 1,
      "checked-children": "使用",
      "un-checked-children": "不使用"
    },
    model: {
      value: _vm.useCode,
      callback: function callback($$v) {
        _vm.useCode = $$v;
      },
      expression: "useCode"
    }
  }), _vm.useCode ? _c('a-input', {
    directives: [{
      name: "decorator",
      rawName: "v-decorator",
      value: ['activationCode', _vm.validatorRules.activationCode],
      expression: "['activationCode', validatorRules.activationCode]"
    }],
    attrs: {
      "disabled": _vm.step == 1,
      "placeholder": "请填写激活码"
    }
  }) : _vm._e()], 1)], 1), _vm.applyConfig.school > 0 ? _c('a-col', {
    attrs: {
      "xs": 24,
      "sm": 20
    }
  }, [_c('a-form-item', {
    attrs: {
      "label": "学校/机构"
    }
  }, [_vm.schoolType == 1 ? _c('j-search-select-tag', {
    directives: [{
      name: "decorator",
      rawName: "v-decorator",
      value: ['school', _vm.validatorRules.school],
      expression: "['school', validatorRules.school]"
    }],
    ref: "searchTag",
    attrs: {
      "disabled": _vm.model.activationCode || _vm.step == 1,
      "placeholder": "请选择学校/机构",
      "async": true,
      "dict": "teaching_agent,agent_name,id,has_child=0"
    }
  }) : _vm._e(), _vm.schoolType == 2 ? _c('a-input', {
    directives: [{
      name: "decorator",
      rawName: "v-decorator",
      value: ['school', _vm.validatorRules.school],
      expression: "['school', validatorRules.school]"
    }],
    attrs: {
      "readOnly": _vm.model.activationCode || _vm.step == 1
    }
  }) : _vm._e(), _c('a-radio-group', {
    attrs: {
      "disabled": _vm.model.activationCode || _vm.step == 1,
      "default-value": "1",
      "button-style": "solid"
    },
    on: {
      "change": _vm.schoolSelected
    },
    model: {
      value: _vm.schoolType,
      callback: function callback($$v) {
        _vm.schoolType = $$v;
      },
      expression: "schoolType"
    }
  }, [_c('a-radio-button', {
    attrs: {
      "value": 1
    }
  }, [_vm._v("搜索")]), _c('a-radio-button', {
    attrs: {
      "value": 2
    }
  }, [_vm._v("手动输入")])], 1)], 1)], 1) : _vm._e(), _vm.eventInfo.applyTeam == 1 ? _c('a-col', {
    attrs: {
      "xs": 24,
      "sm": 15
    }
  }, [_c('a-collapse', {
    attrs: {
      "defaultActiveKey": "1"
    }
  }, [_c('a-collapse-panel', {
    key: "1",
    attrs: {
      "header": "队友信息 (如单人项目，不填)",
      "forceRender": ""
    }
  }, [_c('a-form-item', {
    attrs: {
      "label": "队友姓名"
    }
  }, [_c('a-input', {
    directives: [{
      name: "decorator",
      rawName: "v-decorator",
      value: ['teammateNames'],
      expression: "['teammateNames']"
    }],
    attrs: {
      "disabled": _vm.step == 1,
      "placeholder": ""
    }
  })], 1), _c('a-form-item', {
    attrs: {
      "label": "证件号码"
    }
  }, [_c('a-input', {
    directives: [{
      name: "decorator",
      rawName: "v-decorator",
      value: ['teammateIdcards'],
      expression: "['teammateIdcards']"
    }],
    attrs: {
      "disabled": _vm.step == 1,
      "placeholder": ""
    }
  })], 1), _c('a-form-item', {
    attrs: {
      "label": "年级"
    }
  }, [_c('j-dict-select-tag', {
    directives: [{
      name: "decorator",
      rawName: "v-decorator",
      value: ['teammateGrades'],
      expression: "['teammateGrades']"
    }],
    attrs: {
      "disabled": _vm.step == 1,
      "trigger-change": true,
      "dictCode": "grade",
      "placeholder": "请选择年级"
    }
  })], 1)], 1)], 1)], 1) : _vm._e(), _c('a-divider'), _vm.model.eventCategory && _vm.step == 1 ? _c('a-col', {
    attrs: {
      "xs": 24,
      "sm": 20
    }
  }, [_c('a-alert', {
    attrs: {
      "message": "参与测评项目确认",
      "type": "info",
      "show-icon": ""
    }
  }, [_c('span', {
    attrs: {
      "slot": "description"
    },
    slot: "description"
  }, [_vm._v("\n            您选择了"), _c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v(_vm._s(_vm.model.eventCategory.split(',').length))]), _vm._v("个赛项，报名费用"), _c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v(_vm._s(_vm.applyPrice))]), _vm._v("元。\n            "), _vm.model.activationCode ? _c('span', [_vm._v("使用激活码进行全额抵扣。")]) : _vm._e()])])], 1) : _vm._e()], 1)], 1)], 1), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.step == 2,
      expression: "step==2"
    }]
  }, [!_vm.eventInfo.eventApplyOk ? _c('h1', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("报名成功")]) : _vm._e(), _c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.eventInfo.eventApplyOk)
    }
  })]), _c('div', {
    staticClass: "btns"
  }, [_vm.step == 0 || _vm.step == 2 ? _c('a-button', {
    staticClass: "btn",
    attrs: {
      "type": "primary",
      "size": "large"
    },
    on: {
      "click": _vm.nextStep
    }
  }, [_vm._v("下一步")]) : _vm._e(), _vm.step == 1 ? _c('a-button', {
    staticClass: "btn",
    attrs: {
      "type": "primary",
      "size": "large"
    },
    on: {
      "click": function click($event) {
        _vm.step = 0;
        _vm.confirmLoading = false;
      }
    }
  }, [_vm._v("上一步")]) : _vm._e(), _vm.step == 1 ? _c('a-button', {
    staticClass: "btn",
    attrs: {
      "type": "primary",
      "size": "large",
      "loading": _vm.confirmLoading
    },
    on: {
      "click": _vm.handleOk
    }
  }, [_vm._v("立即报名")]) : _vm._e()], 1), _c('EventPay', {
    ref: "eventPay",
    on: {
      "payOk": _vm.payOk
    }
  }), _c('EventAppleNoticeModal', {
    ref: "applyNotice"
  }), _c('PhotoModal', {
    ref: "photoModal",
    on: {
      "ok": _vm.photoChange
    }
  })], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };